/**
 * @generated SignedSource<<45e005c9f519c6763c1097cf870f59fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type MilestoneRowMenu$data = {
  readonly id: string;
  readonly " $fragmentType": "MilestoneRowMenu";
};
export type MilestoneRowMenu$key = {
  readonly " $data"?: MilestoneRowMenu$data;
  readonly " $fragmentSpreads": FragmentRefs<"MilestoneRowMenu">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MilestoneRowMenu",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Milestone",
  "abstractKey": null
};

(node as any).hash = "d01fc6ce371141a0fd1c9378538bf884";

export default node;
